export const CHECK_CUSTOMS_STATUS_FOR_ORDERS_REQUEST = 'CHECK_CUSTOMS_STATUS_FOR_ORDERS_REQUEST';
export const CHECK_CUSTOMS_STATUS_FOR_ORDERS_SUCCESS = 'CHECK_CUSTOMS_STATUS_FOR_ORDERS_SUCCESS';
export const CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_REQUEST = 'CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_REQUEST';
export const CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_SUCCESS = 'CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_SUCCESS';

export const checkCustomsStatusForOrders = (salesOrderIds) => ({
  type: CHECK_CUSTOMS_STATUS_FOR_ORDERS_REQUEST,
  salesOrderIds,
});

export const checkCustomsStatusForOrdersSuccess = (customsStatusList) => ({
  type: CHECK_CUSTOMS_STATUS_FOR_ORDERS_SUCCESS,
  customsStatusList,
});

export const checkCustomsStatusForFulfillmentPlans = (fulfillmentPlanIds) => ({
  type: CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_REQUEST,
  fulfillmentPlanIds,
});

export const checkCustomsStatusForFulfillmentPlansSuccess = (customsStatusList) => ({
  type: CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_SUCCESS,
  customsStatusList,
});
